/* unplugin-vue-components disabled */import { render } from "./TopNavigationMenu.vue?vue&type=template&id=8d9ade04"
import script from "./TopNavigationMenu.vue?vue&type=script&lang=js"
export * from "./TopNavigationMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__